/*Generated from the `:::slide{key="eea0ef1e-8f58-46da-8bb0-68c8f1f89361" slug="pinyin"}` (simplified/001-P1/001/岸.mdx), `:::slide{key="01aa16b9-2181-4bf1-bd73-7d56bcad7698" slug="pinyin-syllables"}` (simplified/001-P1/001/岸.mdx), `:::slide{key="0bd15ec6-4f05-42c9-84d7-3afee312831c" slug="pinyin-tones"}` (simplified/001-P1/001/岸.mdx) directives, merged because they share one anchor. Edit the lesson or level file.*/
import {useMDXComponents} from "@bacons/mdx";
import {Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs} from "react/jsx-runtime";
function _createMdxContent(props) {
  const components = {
    ...useMDXComponents(),
    ...props.components
  };
  const {SlidePageBlock, ...html} = components;
  if (!SlidePageBlock) _missingMdxReference("SlidePageBlock", true);
  if (!html) _missingMdxReference("html", false);
  if (!html.li) _missingMdxReference("html.li", true);
  if (!html.p) _missingMdxReference("html.p", true);
  if (!html.strong) _missingMdxReference("html.strong", true);
  if (!html.ul) _missingMdxReference("html.ul", true);
  return _jsxs(_Fragment, {
    children: [_jsx(SlidePageBlock, {
      block: "0",
      section: "0",
      kind: "p",
      count: "8",
      children: _jsx(html.p, {
        children: "To represent how characters are pronounced, Chinese uses a notation called pinyin.",
        components: html
      }),
      components: html
    }), _jsx(SlidePageBlock, {
      block: "1",
      section: "0",
      kind: "p",
      count: "8",
      children: _jsxs(html.p, {
        children: ["Pinyin uses Latin letters to represent the sound of a single syllable for a character, and a ", _jsx(html.strong, {
          children: "diacritic",
          components: html
        }), " (a mark above the letter) to indicate its tone."]
      }),
      components: html
    }), _jsx(SlidePageBlock, {
      block: "2",
      section: "1",
      kind: "p",
      count: "8",
      children: _jsxs(html.p, {
        children: ["Pinyin ", _jsx(html.strong, {
          children: "syllables",
          components: html
        }), " are built from ", _jsx(html.strong, {
          children: "initials",
          components: html
        }), " and ", _jsx(html.strong, {
          children: "finals",
          components: html
        }), "."]
      }),
      components: html
    }), _jsx(SlidePageBlock, {
      block: "3",
      section: "1",
      kind: "p",
      count: "8",
      children: _jsxs(html.p, {
        children: ["The ", _jsx(html.strong, {
          children: "initial",
          components: html
        }), " is the starting consonant sound, while the ", _jsx(html.strong, {
          children: "final",
          components: html
        }), " is the vowel-based part after the initial."]
      }),
      components: html
    }), _jsx(SlidePageBlock, {
      block: "4",
      section: "1",
      kind: "p",
      count: "8",
      children: _jsxs(html.p, {
        children: ["Only the ", _jsx(html.strong, {
          children: "initial",
          components: html
        }), " is optional—a ", _jsx(html.strong, {
          children: "syllable",
          components: html
        }), " is either an ", _jsx(html.strong, {
          children: "initial-final",
          components: html
        }), " pair or a ", _jsx(html.strong, {
          children: "lone final",
          components: html
        }), "."]
      }),
      components: html
    }), _jsx(SlidePageBlock, {
      block: "5",
      section: "2",
      kind: "p",
      keepWithNext: "true",
      count: "8",
      children: _jsxs(html.p, {
        children: ["Every Pinyin syllable is pronounced with one of five ", _jsx(html.strong, {
          children: "tones",
          components: html
        }), ":"]
      }),
      components: html
    }), _jsx(SlidePageBlock, {
      block: "6",
      section: "2",
      kind: "ul",
      count: "8",
      children: _jsxs(html.ul, {
        children: [_jsx(html.li, {
          children: "high tone",
          components: html
        }), _jsx(html.li, {
          children: "rising tone",
          components: html
        }), _jsx(html.li, {
          children: "low tone",
          components: html
        }), _jsx(html.li, {
          children: "falling tone",
          components: html
        }), _jsx(html.li, {
          children: "neutral tone",
          components: html
        })]
      }),
      components: html
    }), _jsx(SlidePageBlock, {
      block: "7",
      section: "2",
      kind: "p",
      count: "8",
      children: _jsxs(html.p, {
        children: ["We'll first learn the ", _jsx(html.strong, {
          children: "falling tone",
          components: html
        }), " with a character whose Pinyin is a lone final."]
      }),
      components: html
    })]
  });
}
export default function MDXContent(props = {}) {
  const {wrapper: MDXLayout} = props.components || ({});
  return MDXLayout ? _jsx(MDXLayout, {
    ...props,
    children: _jsx(_createMdxContent, {
      ...props
    })
  }) : _createMdxContent(props);
}
function _missingMdxReference(id, component) {
  throw new Error("Expected " + (component ? "component" : "object") + " `" + id + "` to be defined: you likely forgot to import, pass, or provide it.");
}
